import styled, { css } from 'styled-components'

export const TextElement = styled.p`
  margin: 0;
`

export const UnderlineTextElement = styled.span`
  text-decoration: underline;
`

export const HiddenInputElement = styled.input`
  display: none;
`

export const ContainerElement = styled.button`
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #ccc;
  border-radius: 4px;
  width: 98%;
  cursor: pointer;
  padding: 0.4rem;
  gap: 0.4rem;
  color: #ccc;
  height: 2.8rem;

  &:hover {
    border: 2px solid #2e8ab8;
    color: #2e8ab8;
  }

  ${(props) =>
    props.isUploading &&
    css`
      cursor: not-allowed;
      border: 2px solid #2e8ab8;
      color: #2e8ab8;
      background-color: rgba(25, 118, 210, 0.1);
    `}

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;

      &:hover {
        border: 2px dashed #ccc;
        color: #ccc;
      }
    `}
`
